import React, { useState } from 'react';
import '../../assets/css/domains/Domains.css';

const Domains = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const domains = [
    {
      id: 1,
      title: 'Computer Science & IT',
      icon: 'fas fa-laptop-code',
      description: 'Coding groups, DSA practice, AI coding assistant, and project collaboration.',
      image: 'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?w=600&q=80',
      gradient: 'linear-gradient(135deg, rgba(135, 206, 235, 0.85), rgba(70, 130, 180, 0.85))'
    },
    {
      id: 2,
      title: 'Artificial Intelligence & Data Science',
      icon: 'fas fa-brain',
      description: 'AI-powered notes summarization, ML study circles, datasets sharing, and smart quizzes.',
      image: 'https://images.unsplash.com/photo-1555255707-c07966088b7b?w=600&q=80',
      gradient: 'linear-gradient(135deg, rgba(0, 191, 255, 0.85), rgba(30, 144, 255, 0.85))'
    },
    {
      id: 3,
      title: 'Business & Management',
      icon: 'fas fa-briefcase',
      description: 'Case study discussions, team collaboration, presentations, and performance tracking.',
      image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&q=80',
      gradient: 'linear-gradient(135deg, rgba(135, 206, 235, 0.85), rgba(70, 130, 180, 0.85))'
    },
    {
      id: 4,
      title: 'Medical & Health Sciences',
      icon: 'fas fa-heartbeat',
      description: 'Group study sessions, visual notes, peer discussions, and quiz-based learning.',
      image: 'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=600&q=80',
      gradient: 'linear-gradient(135deg, rgba(0, 191, 255, 0.85), rgba(30, 144, 255, 0.85))'
    },
    {
      id: 5,
      title: 'Engineering & Technology',
      icon: 'fas fa-cogs',
      description: 'Subject-wise hubs, live interaction rooms, notes sharing, and progress monitoring.',
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=600&q=80',
      gradient: 'linear-gradient(135deg, rgba(135, 206, 235, 0.85), rgba(70, 130, 180, 0.85))'
    },
    {
      id: 6,
      title: 'General Education',
      icon: 'fas fa-graduation-cap',
      description: 'Competitive exam preparation, daily quizzes, AI summaries, and collaborative learning.',
      image: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=600&q=80',
      gradient: 'linear-gradient(135deg, rgba(0, 191, 255, 0.85), rgba(30, 144, 255, 0.85))'
    }
  ];

  return (
    <div className="dm-domains-page">
      {/* Hero Section */}
      <section className="dm-domains-hero">
        <div className="dm-hero-background"></div>
        <div className="container">
          <div className="dm-hero-content">
            <h6 className="dm-hero-badge">EXPLORE LEARNING DOMAINS</h6>
            <h1 className="dm-hero-title">Choose Your Study Domain</h1>
            <p className="dm-hero-subtitle">
              Join specialized study groups tailored to your field of interest. 
              Connect with peers, share knowledge, and excel together.
            </p>
          </div>
        </div>
      </section>

      {/* Domains Grid Section */}
      <section className="dm-domains-grid-section">
        <div className="container">
          <div className="dm-section-header">
      
            <h2 className="dm-section-title">Explore Study Domains</h2>
         
          </div>

          <div className="row g-4">
            {domains.map((domain, index) => (
              <div 
                className="col-lg-4 col-md-6" 
                key={domain.id}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div 
                  className="dm-domain-card"
                  onMouseEnter={() => setHoveredCard(domain.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  {/* Card Image */}
                  <div className="dm-domain-image-wrapper">
                    <img 
                      src={domain.image} 
                      alt={domain.title}
                      className="dm-domain-image"
                    />
                    <div 
                      className="dm-domain-image-overlay"
                      style={{ background: domain.gradient }}
                    ></div>
                  </div>

                  {/* Card Content */}
                  <div className="dm-domain-content">
                    <div className="dm-domain-icon-wrapper">
                      <i className={domain.icon}></i>
                    </div>
                    <h3 className="dm-domain-title">{domain.title}</h3>
                    <p className="dm-domain-description">{domain.description}</p>                   
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="dm-domains-features-section">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-6">
              <div className="dm-features-content">
             
                <h2 className="dm-section-title">Benefits of Domain-Specific Learning</h2>
                <div className="dm-features-list">
                  <div className="dm-feature-item">
                    <div className="dm-feature-icon">
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="dm-feature-text">
                      <h4>Connect with Peers</h4>
                      <p>Join students studying the same subjects and build lasting connections</p>
                    </div>
                  </div>

                  <div className="dm-feature-item">
                    <div className="dm-feature-icon">
                      <i className="fas fa-book-open"></i>
                    </div>
                    <div className="dm-feature-text">
                      <h4>Tailored Resources</h4>
                      <p>Access domain-specific study materials, notes, and AI-powered summaries</p>
                    </div>
                  </div>

                  <div className="dm-feature-item">
                    <div className="dm-feature-icon">
                      <i className="fas fa-chart-line"></i>
                    </div>
                    <div className="dm-feature-text">
                      <h4>Track Progress</h4>
                      <p>Monitor your learning journey with detailed analytics and insights</p>
                    </div>
                  </div>

                  <div className="dm-feature-item">
                    <div className="dm-feature-icon">
                      <i className="fas fa-comments"></i>
                    </div>
                    <div className="dm-feature-text">
                      <h4>Collaborative Learning</h4>
                      <p>Participate in group discussions, live sessions, and peer reviews</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="dm-features-image-wrapper">
                <img 
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=700&q=80" 
                  alt="Students collaborating"
                  className="dm-features-image"
                />
                <div className="dm-floating-stats">
                  <div className="dm-stat-card">
                    <h3>6+</h3>
                    <p>Domains</p>
                  </div>
                  <div className="dm-stat-card">
                    <h3>1000+</h3>
                    <p>Students</p>
                  </div>
                  <div className="dm-stat-card">
                    <h3>50+</h3>
                    <p>Study Groups</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="dm-domains-cta-section">
        <div className="container">
          <div className="dm-cta-wrapper">
            <div className="dm-cta-content">
              <h2 className="dm-cta-title">Ready to Start Your Learning Journey?</h2>
              <p className="dm-cta-description">
                Join thousands of students already learning and growing in their chosen domains
              </p>
              <button className="dm-btn-cta-primary">
                <i className="fas fa-user-plus"></i>
                <span>Join CircleHub Today</span>
              </button>
            </div>
            <div className="dm-cta-decoration">
              <div className="dm-decoration-circle dm-circle-1"></div>
              <div className="dm-decoration-circle dm-circle-2"></div>
              <div className="dm-decoration-circle dm-circle-3"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Domains;